import { createSlice } from "@reduxjs/toolkit";
import { deliveryTrendState, quickState, riskStatusState } from "../../state";

const getQuickStatsSlice = createSlice({
  name: "DASHBOARD_QUICK_STATS_SLICE",
  initialState: quickState,
  reducers: {
    startQuickStats: (state) => {
      state.loading = true;
      state.error = null;
    },
    successQuickStats: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorQuickStats: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const getDeliveryTrendSlice = createSlice({
  name: "DASHBOARD_DELIVERY_TREND_STATS_SLICE",
  initialState: deliveryTrendState,
  reducers: {
    startDeliveryTrendStats: (state) => {
      state.loading = true;
      state.error = null;
    },
    successDeliveryTrendStats: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorDeliveryTrendStats: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const getRiskStatusSlice = createSlice({
  name: "DASHBOARD_RISK_STATUS_SLICE",
  initialState: riskStatusState,
  reducers: {
    startRiskStatus: (state) => {
      state.loading = true;
      state.error = null;
    },
    successRiskStatus: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorRiskStatus: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { startQuickStats, successQuickStats, errorQuickStats } =
  getQuickStatsSlice.actions;
export const {
  startDeliveryTrendStats,
  successDeliveryTrendStats,
  errorDeliveryTrendStats,
} = getDeliveryTrendSlice.actions;
export const { startRiskStatus, successRiskStatus, errorRiskStatus } =
  getRiskStatusSlice.actions;

export const getQuickStatsReducer = getQuickStatsSlice.reducer;
export const getDeliveryTrendReducer = getDeliveryTrendSlice.reducer;
export const getRiskStatusReducer = getRiskStatusSlice.reducer;
